import { X } from "lucide-react";
import { ProposalLoadingScreen } from "../proposal/LoadingScreen";

// Full screen preview of the client loading screen with this
// announcement, exactly as a client would see it.
export function AnnouncementPreview({ item, onClose }) {
  return (
    <div className="fixed inset-0 z-50" data-testid="announcement-preview">
      <ProposalLoadingScreen announcement={item} ready onContinue={onClose} />
      <button
        type="button"
        onClick={onClose}
        className="absolute top-4 right-4 inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-2 text-xs font-mono uppercase tracking-wide text-stone-200 backdrop-blur transition-colors hover:bg-white/20"
        data-testid="announcement-preview-close"
      >
        <X className="w-3.5 h-3.5" /> Close preview
      </button>
      <p className="pointer-events-none absolute top-5 left-1/2 -translate-x-1/2 text-[11px] font-mono uppercase tracking-[0.18em] text-stone-500">
        Preview, as the client sees it
      </p>
    </div>
  );
}
